import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { MARKETS_URL, SIGNUP_URL } from "./links";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10">
      <div className="mx-auto max-w-7xl px-6 pt-28 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col items-start gap-10 pb-24 md:flex-row md:items-end md:justify-between"
        >
          <div>
            <p className="mb-4 text-[10px] uppercase tracking-[0.3em] text-gold">
              Final call
            </p>
            <h2 className="font-serif text-5xl font-light tracking-tighter text-white sm:text-6xl">
              The terminal
              <br />
              <span className="italic text-gold">is open.</span>
            </h2>
          </div>
          <a
            data-testid="footer-markets-btn"
            href={MARKETS_URL}
            className="group flex items-center gap-3 rounded-full bg-gold px-10 py-5 text-xs uppercase tracking-[0.2em] text-ink transition-colors duration-300 hover:bg-gold-light"
          >
            Open Aureon Markets
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
          </a>
        </motion.div>
      </div>

      <div className="select-none overflow-hidden" aria-hidden="true">
        <motion.p
          initial={{ y: "40%" }}
          whileInView={{ y: "12%" }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
          className="whitespace-nowrap text-center font-serif text-[22vw] font-light leading-none tracking-tighter"
          style={{ WebkitTextStroke: "1px rgba(212, 175, 55, 0.18)", color: "transparent" }}
        >
          AUREON
        </motion.p>
      </div>

      <div className="relative border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-8 text-[10px] uppercase tracking-[0.25em] text-white/35 sm:flex-row sm:items-center sm:justify-between lg:px-10">
          <span data-testid="footer-brand">Aureon Global Markets · N° 001</span>
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            <a
              data-testid="footer-markets-link"
              href={MARKETS_URL}
              className="transition-colors duration-300 hover:text-gold"
            >
              Markets
            </a>
            <a
              data-testid="footer-signup-link"
              href={SIGNUP_URL}
              className="transition-colors duration-300 hover:text-gold"
            >
              Create account
            </a>
            <a
              data-testid="footer-signin-link"
              href="/terminal"
              className="transition-colors duration-300 hover:text-gold"
            >
              Sign in
            </a>
            <a data-testid="footer-terms-link" href="/terms" className="transition-colors duration-300 hover:text-gold">
              Terms
            </a>
            <a data-testid="footer-privacy-link" href="/privacy" className="transition-colors duration-300 hover:text-gold">
              Privacy
            </a>
            <a data-testid="footer-risk-link" href="/risk" className="transition-colors duration-300 hover:text-gold">
              Risk
            </a>
            <a data-testid="footer-contact-link" href="/contact" className="transition-colors duration-300 hover:text-gold">
              Contact
            </a>
          </div>
          <span>© 2017 · Private Terminal</span>
        </div>
      </div>
    </footer>
  );
}
